export default __webpack_public_path__ + "static/media/arrow.324d7eda.svg";